jQuery.event.special.touchstart = {
  setup: function( _, ns, handle ) {
      this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
  }
};

function currentYear() {
    new Date().getFullYear();
}
rivets.configure({
    // Attribute prefix in templates
    prefix: 'rv',
  
    // Preload templates with initial data on bind
    preloadData: true,
  
    // Root sightglass interface for keypaths
    rootInterface: '.',
  
    // Template delimiters for text bindings
    templateDelimiters: ['{', '}'],
  
    // Augment the event handler of the on-* binder
    handler: function(target, event, binding) {
      this.call(target, event, binding.view.models)
    }
  
  });

$(document).on('cart.requestStarted', function(event, cart) {
  document.querySelector('#button-cart').innerHTML = 'laden...';
  document.querySelector('#button-cart').style.backgroundColor = "#759679";
  document.querySelector('#button-cart').disabled = true;
  document.querySelector('#button-cart').style.cursor = "not-allowed";

});

$(document).on('cart.requestComplete', function(event, cart) {
  document.querySelector('#button-cart').innerHTML = 'Ik ga bestellen';
  document.querySelector('#button-cart').style.backgroundColor = "#059449";
  document.querySelector('#button-cart').disabled = false;
  document.querySelector('#button-cart').style.cursor = "pointer";

});

$(function () {
  $('#create_customer').submit(function (e) {
      if ($('input[name="customer[password]"]').val() != $(
              'input[name="customer[password_confirmation]"]').val()) {
          e.preventDefault();

          document.getElementById('error-list').innerHTML = "<li>Wachtwoorden komen niet overeen met elkaar.</li>"
      }
  });
});

